module.exports = __webpack_public_path__ + "images/moneyman-574d9873.png";